import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

export interface PdfViewerErrorContexts {
  user: { id: number; email: string; username: string; roleName: string };
  contexts: Array<{ name: string; value: { [key: string]: string | number } }>;
}

export const { provide: providePdfViewerErrorContexts, inject: injectPdfViewerErrorContexts } =
  createProviderToken<Observable<PdfViewerErrorContexts>>('Pdf viewer error contexts')();
